import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  listClients,
  getClientTemplates,
  addClientsToBranch,
} from "../../api/server";
import {
  notifyError,
  withNotifications,
} from "../notifications/notificationsSlice";

export const fetchPage = createAsyncThunk(
  "clients/loadPage",
  async (listParams, thunkAPI) => {
    const { error, data } = await listClients(listParams);
    if (error) {
      thunkAPI.dispatch(notifyError({ title: "Load clients", message: error }));
    }
    return data;
  }
);

export const getTemplates = createAsyncThunk(
  "clients/getTemplates",
  async (listParams, thunkAPI) => {
    const { error, data } = await getClientTemplates();
    if (error) {
      thunkAPI.dispatch(notifyError({ title: "Load clients", message: error }));
    }
    return data;
  }
);

export const addClients = createAsyncThunk(
  "clients/addClients",
  withNotifications(
    addClientsToBranch,
    "add_client",
    "add_client_success",
    "add_client_error"
  )
);

const onItemChanged = (state, action) => {
  const changedItem = action.payload.data;
  const { items } = state.page;
  state.page.items = items.map((i) => {
    if (i.id === changedItem.id) {
      return changedItem;
    }
    return i;
  });
};
const initialPageSize = 10;
const initialState = {
  page: {
    current: 1,
    pageSize: initialPageSize,
    filter: {
      freeText: null,
    },
    order: {
      field: "name",
      order: "descend",
    },
    items: [],
  },
  queryParams: {
    include_not_active: false,
  },
  templates: {
    items: [],
  },
};

const clientsSlice = createSlice({
  name: "clients",
  initialState: initialState,
  reducers: {
    setPage(state, { payload: page }) {
      state.page = page;
    },
    setQueryParams(state, { payload: query }) {
      state.queryParams = query;
    },
    reset(state, action) {
      state.page = initialState.page;
    },
  },
  extraReducers: {
    [fetchPage.fulfilled]: (state, action) => {
      state.page = { ...state.page, ...action.payload };
    },
    [fetchPage.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getTemplates.fulfilled]: (state, action) => {
      state.templates = action.payload;
    },
    [getTemplates.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [addClients.fulfilled]: (state, action) => {
      console.log(action.payload);
      // state.page = { ...state.page, items: action.payload };
    },
    [addClients.rejected]: (state, action) => {
      state.error = action.payload;
    },
    "clientDetails/update/fulfilled": onItemChanged,
    "clientDetails/delete/fulfilled": (state, action) => {
      const { items } = state.page;
      state.page.items = items.filter((item) => item.id !== action.meta.arg);
    },
  },
});

export const { setPage, setQueryParams, reset } = clientsSlice.actions;

export default clientsSlice.reducer;

export const loadPage = (params, query) => (dispatch, getState) => {
  const newState = {
    ...getState().clients.page,
    ...params,
  };
  const scopePrefix = getState().user.scopePrefix;
  dispatch(setPage(newState));
  dispatch(setQueryParams(query));
  dispatch(
    fetchPage({
      ...newState,
      scopePrefix,
      query,
    })
  );
};

export const reload = () => (dispatch, getState) => {
  return dispatch(loadPage(getState().clients.page));
};
